<template>
  <div class="animated fadeIn">
    <Row>
      <Input search @on-search="onFilterClick" size="small" v-model="keywordFilter" placeholder="关键字"
             style="width: 200px; margin-right: 3px;"></Input>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onFilterClick">查询</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onQueryAllClick">全量同步省平台</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onSyncJt808AllClick">全量同步Jt808</Button>
      <Button size="small" type="primary" style="margin-right: 3px;" @click="onOfflineSendCmdClick">离线车辆发送使能指令</Button>
    </Row>
    <Row style="margin-top: 3px;">
      <div style="width: 100%;">
        <div style="position:relative;">
          <context-menu ref="contextMenuRef" :menuList="menuList" @callback="onContextMenuCallback"></context-menu>
          <Table border highlight-row size="small" height="600" :columns="columns" :stripe="true" :data="content"
                 ref="table" :height="tableHeight"
                 @on-sort-change="sortChange" @on-filter-change="filterChange"
                 @contextmenu.prevent.native="onTableRightClick($event)"></Table>
          <div style="position:absolute;top:0px;width:100%;height:100%;display: flex;
                            align-items: center;
                            justify-content: center;background: rgba(210, 216, 222, 0.5);" v-if="listLoadding">
            <Spin size="large"></Spin>
            <h6 style="color:#2d8cf0;margin-top:10px;">正在获取数据...</h6>
          </div>
        </div>
        <Page size="small" :total="totalElements" :page-size="pageSize" :current="pageIndex" :show-total="true"
              show-elevator @on-change="setPage"
              show-sizer @on-page-size-change="refreshPage" :page-size-opts="pagesizeopts"
              style="text-align:right;margin-top:3px;"></Page>
      </div>
    </Row>
    <web-table-columns-modal :columnList.sync="columns" :tableName="$options.name"
                             v-model="webTableColumnsModal"></web-table-columns-modal>
  </div>
</template>

<script>
  import Vue from 'vue'
  import store from '@/store'
  import { mapActions } from 'vuex'
  import { genQueryParam, genSortParam } from '@/libs/queryparamhelper'
  import { numberFormat } from '@/libs/numberutil'
  import { genURLParams } from '@/libs/urlparamhelper'

  export default {
    name: 'gddlysjgvehicledatas',
    components: {

    },
    data () {
      return {

        webTableColumnsModal: false,
        menuList: [
          { title: '设置表格列', content: {} }
        ],

        statusFilter: null,

        pageFilter: 30,
        pagesizeopts:[30, 50,100,200],
        keywordFilter: null,
        tableHeight: 160,
        pageIndex: 1,
        sort: null,
        listLoadding: false,

        columns: [
          {
            title: 'ID',
            resizable: true,
            key: 'id',
            sortable: 'custom',
            tooltip: 'true',
            width: 80
          },
          {
            title: '车牌号',
            resizable: true,
            key: 'registrationNum',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.registrationNum) {
                return h('div', params.row.registrationNum)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '车辆类型',
            resizable: true,
            key: 'vehicleType',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.vehicleType) {
                return h('div', params.row.vehicleType)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '主机号',
            resizable: true,
            key: 'terminalNum',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.terminalNum) {
                return h('div', params.row.terminalNum)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: 'sim卡号',
            resizable: true,
            key: 'simNum',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.simNum) {
                return h('div', params.row.simNum)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: 'Iccid',
            resizable: true,
            key: 'iccid',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 120,
            render: (h, params) => {

              if (params.row.iccid) {
                return h('div', params.row.iccid)
              } else {
                return h('div', '无')
              }
            }
          },
          {
            title: '业户名称',
            resizable: true,
            key: 'yeHuMingCheng',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 300,
            render: (h, params) => {
                if (params.row.yeHuMingCheng) {
                  return h('div', params.row.yeHuMingCheng)
                } else {
                  return h('div', '无')
                }
            }
          },
          {
            title: 'Jt808最后接收时间',
            resizable: true,
            key: 'jt808LastRecvDatetime',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            render: (h, params) => {
              if (params.row.jt808LastRecvDatetime) {
                let d = new Date(params.row.jt808LastRecvDatetime)
                return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
              } else {
                return h('div', {}, '无')
              }
            }
          },
          {
            title: 'Jt808最后定位时间',
            resizable: true,
            key: 'jt808LastLocateDatetime',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            render: (h, params) => {
              if (params.row.jt808LastLocateDatetime) {
                let d = new Date(params.row.jt808LastLocateDatetime)
                return h('div', {}, d.Format('yyyy年MM月dd hh:mm:ss'))
              } else {
                return h('div', {}, '无')
              }
            }
          },
          {
            title: 'Jt808状态',
            resizable: true,
            key: 'jt808State',
            width: 110,
            ellipsis: 'true',
            tooltip: 'true',
            render: (h, params) => {
              const task_status = params.row.jt808State
              if (task_status == 2) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'success'
                    }
                  }, '行驶')
                ])
              } else if (task_status == 1) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'warning'
                    }
                  }, '熄火')
                ])
              } else if (task_status == 0) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'error'
                    }
                  }, '离线')
                ])
              } else if (task_status == 3) {
                return h('div', [
                  h('Tag', {
                    props: {
                      size: 'small',
                      type: 'dot',
                      color: 'blue'
                    }
                  }, '停车未熄火')
                ])
              } else {
                // return h('div', [
                //   h('Tag', {
                //     props: {
                //       type: 'dot',
                //       color: "black"
                //     }
                //   }, "未知")
                // ]);
                // console.log('未知')
                // console.log(params.row)
                return h('div', task_status)
              }
            }
          },
          {
            title: 'jt808状态时长',
            resizable: true,
            ellipsis: 'true',
            tooltip: 'true',
            width: 180,
            render: function (h, params) {
              if (!params.row.jt808ChangeTerminalStateDatetime) {
                return h('label', '无')
              }
              let date3 = new Date().getTime() - params.row.jt808ChangeTerminalStateDatetime
              let leave1 = date3
              let hours = Math.floor(leave1 / (3600 * 1000))
              // 计算相差分钟数
              let leave2 = leave1 % (3600 * 1000) // 计算小时数后剩余的毫秒数
              let minutes = Math.floor(leave2 / (60 * 1000))
              // 计算相差秒数
              let leave3 = leave2 % (60 * 1000) // 计算分钟数后剩余的毫秒数
              let seconds = Math.round(leave3 / 1000)
              let result = ''
              if (hours > 0) {
                result += hours + '小时'
              }
              if (minutes > 0) {
                result += minutes + '分'
              }
              if (seconds > 0) {
                result += seconds + '秒'
              }
              return h('label', result)
            }
          },
          {
            title: '省平台状态',
            resizable: true,
            key: 'status',
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            width: 160,
            filters: [
              { label: '在线', value: 1 },
              { label: '离线', value: 2 }
            ],
            filterMultiple: true,
            filterRemote: (val) => {
              if (val && val.length > 0) {
                this.statusFilter = []
                val.forEach(item => {
                  this.statusFilter.push(genQueryParam('status', 'EQ', item))
                })
              } else {
                this.statusFilter = null
              }
              this.setPage(1)
            },
            render: (h, params) => {
              let status = params.row.status
              if (status === 1) {
                return h('div', {
                  style: {
                    color: 'green'
                  }
                }, '在线')
              } else if (status === 2) {
                return h('div', {
                  style: {
                    color: 'red'
                  }
                }, '离线')
              } else {
                return h('div', {

                }, '无')
              }
            }
          },
          {
            title: '省平台最后在线时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'lastOnDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.lastOnDatetime) {
                let d = new Date(params.row.lastOnDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '省平台同步时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'analyseDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.analyseDatetime) {
                let d = new Date(params.row.analyseDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '创建时间',
            resizable: true,
            sortable: 'custom',
            ellipsis: 'true',
            tooltip: 'true',
            key: 'createDatetime',
            width: 180,
            render: function (h, params) {
              if (params.row.createDatetime) {
                let d = new Date(params.row.createDatetime)
                return h('div', d.Format('yyyy年MM月dd日 hh:mm:ss'))
              }
            }
          },
          {
            title: '操作',
            resizable: true,
            key: 'action',
            align: 'left',
            ellipsis: 'true',
            fixed: 'right',
            width: 300,
            render: (h, params) => {
              return h('div', [
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      store.dispatch('GdDlysjgVehicleDataServ_QuerySingleVehicleInfo', {
                        params: {id:params.row.id},
                        urlparams: null
                      }).then(() => {
                        this.listLoadding = false
                        this.onModifySuccess()
                      }).catch(err => {
                        this.listLoadding = false
                        this.$Message.error(err)
                      })
                    }
                  }
                }, '单台同步'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      store.dispatch('GdDlysjgVehicleDataServ_SendSingleGdDlysjgOffline', {
                        params: {id:params.row.id},
                        urlparams: null
                      }).then(() => {
                        this.$Message.success('发送成功')
                      }).catch(err => {
                        this.$Message.error(err)
                      })
                    }
                  }
                }, '发送使能指令'),
                h('Button', {
                  props: {
                    type: 'primary',
                    size: 'small',
                    disabled: false
                  },
                  style: {
                    marginRight: '5px'
                  },
                  on: {
                    click: () => {
                      store.dispatch('GdDlysjgVehicleDataServ_SendSingleDlysjgParamCmd', {
                        params: {id:params.row.id},
                        urlparams: null
                      }).then(() => {
                        this.$Message.success('发送成功')
                      }).catch(err => {
                        this.$Message.error(err)
                      })
                    }
                  }
                }, '发送参数指令')
              ])
            }
          }
        ]// cloumn
      }// return
    }, // data
    methods: {
      ...mapActions([
        'ClientInfoServ_GetPage'
      ]),
      /**
       * 表格右键回调
       */
      onTableRightClick (e) {
        this.$refs.contextMenuRef.showMenu(e, this.$el, 0, -20)
      },
      /**
       * 右键菜单点击回调
       */
      onContextMenuCallback (item) {
        if (item.title === '设置表格列') {
          this.webTableColumnsModal = true
        }
      },
      onSuccess () {
        this.setPage(1)
      },
      onModifySuccess () {
        this.refreshPage(this.pageFilter)
      },
      onFilterClick () {
        this.setPage(1)
      },
      onOfflineSendCmdClick(){
        store.dispatch('GdDlysjgVehicleDataServ_SendToGdDlysjgOffline', {
          params: null,
          urlparams: null
        }).then(() => {
          this.$Message.success('开始发送')
        }).catch(err => {
          this.$Message.error(err)
        })
      },
      onSyncJt808AllClick(){
        this.listLoadding = true
        store.dispatch('GdDlysjgVehicleDataServ_SyncJt808TerminalNum', {
          params: null,
          urlparams: null
        }).then(() => {
          this.listLoadding = false
          this.$Message.success('同步完成')
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      onQueryAllClick(){
        this.listLoadding = true
        store.dispatch('GdDlysjgVehicleDataServ_QueryVehicleInfos', {
          params: null,
          urlparams: null
        }).then(() => {
          this.listLoadding = false
          this.$Message.success('开始同步')
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      onDeleteClick () {
        this.deleteTracksIntegrityAnalysissModal = true
      },
      onAttentionAnalysisClick () {
        this.analyzeGdDlysjgVehicleReportModal = true
      },
      onExportExcelClick () {
        let queryParams = []
        let qo1 = null
        let qo2 = null
        if (this.stateFilter) {
          qo1 = this.stateFilter
        }
        if (this.offlineFilter) {
          qo2 = this.offlineFilter
        }
        if (this.selectAnalysisDatetime[0] && this.selectAnalysisDatetime[1]) {
          let startDatetime = new Date(this.selectAnalysisDatetime[0]).Format('yyyy-MM-dd 00:00:00')
          let endDatetime = new Date(this.selectAnalysisDatetime[1]).Format('yyyy-MM-dd 23:59:59')
          queryParams.push(genQueryParam('analyzeDatetime', 'BTDT', startDatetime, endDatetime))
        }
        let urlparams = {
          qo1: qo1,
          qo2: qo2,
          q: queryParams,
          keyword: this.keywordFilter
        }
        let url = '/api/da/gddlysjgvehicleanalyzereport/exportexcel' + genURLParams(urlparams)
        window.location.href = url
      },
      filterChange () {
        this.setPage(1)
      },
      sortChange ({ column, key, order }) {
        this.sort = {
          name: key,
          asc: order === 'asc'
        }
        this.refreshPage(this.pageFilter)
      },
      setPage (page) {
        console.log('setPage' + page)
        this.pageIndex = page
        this.listLoadding = true

        let queryParams = []
        let sortParam = null
        let qo1 = null
        let qo2 = null
        let qo3 = null

        if (this.sort) {
          sortParam = genSortParam(this.sort.name, this.sort.asc)
        }

        if(this.statusFilter){
          qo1 = this.statusFilter;
        }

        store.dispatch('GdDlysjgVehicleDataServ_GetPage', {
          params: null,
          urlparams: {
            qo1: qo1,
            q: queryParams,
            ps: this.pageFilter,
            p: page,
            keyword: this.keywordFilter,
            sort: sortParam
          }
        }).then(() => {
          this.listLoadding = false
        }).catch(err => {
          this.listLoadding = false
          this.$Message.error(err)
        })
      },
      // 刷新当前页
      refreshPage (value) {
        this.pageFilter = value
        this.setPage(this.pageIndex)
      }
    },
    computed: {
      totalElements () {
        if (store.getters.get_GdDlysjgVehicleData_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleData_GetPageResult.totalElements
        } else {
          return 0
        }
      },
      content () {
        if (store.getters.get_GdDlysjgVehicleData_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleData_GetPageResult.content
        } else {
          return []
        }
      },
      pageSize () {
        if (store.getters.get_GdDlysjgVehicleData_GetPageResult) {
          return store.getters.get_GdDlysjgVehicleData_GetPageResult.size
        } else {
          return 0
        }
      }
    },
    mounted () {
      this.$nextTick(() => {
        // this.selectAnalysisDatetime = new Date()
        this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        window.onresize = () => {
          this.tableHeight = window.innerHeight - this.$refs.table.$el.offsetTop - 140
        }
        this.setPage(1)
      })
    }
  }
</script>

<style scoped>
</style>
